<template>
  <div class="search-results-totals">
    <SearchQueryTotals
      class="f-ui-1 search-results-totals__results"
      v-if="results.searched"
      v-bind="{ results }"
      v-bind:class="{ suggested: results.suggestionTrigger }"
      :info="search"
    />
    <div
      v-if="featureImages && featureImagesToggle"
      class="search-results-totals__toggle f-ui-1"
      @click="toggleEmit()"
    >
      <span>{{ this.toggleText }}</span>
      <svg
        v-if="toggledImage"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2.5" y="6.12988" width="19" height="13" stroke="#1A47B8" />
        <circle cx="8" cy="10.6299" r="1.5" stroke="#1A47B8" />
        <path d="M2 22.6299L22 3.62988" stroke="#1A47B8" />
        <path
          d="M5 16.6299C6 15.1299 7.5 14.6299 8.5 14.6299C10.5 14.6299 10.5 15.6299 12.5 15.6299C15 15.6299 15.5 11.1299 19.5 11.1299"
          stroke="#1A47B8"
        />
        <rect x="2.5" y="6.12988" width="19" height="13" stroke="#1A47B8" />
        <circle cx="8" cy="10.6299" r="1.5" stroke="#1A47B8" />
        <path
          d="M5 16.6299C6 15.1299 7.5 14.6299 8.5 14.6299C10.5 14.6299 10.5 15.6299 12.5 15.6299C15 15.6299 15.5 11.1299 19.5 11.1299"
          stroke="#1A47B8"
        />
      </svg>
      <svg
        v-else
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2.5" y="6.12988" width="19" height="13" stroke="#1A47B8" />
        <circle cx="8" cy="10.6299" r="1.5" stroke="#1A47B8" />
        <path
          d="M5 16.6299C6 15.1299 7.5 14.6299 8.5 14.6299C10.5 14.6299 10.5 15.6299 12.5 15.6299C15 15.6299 15.5 11.1299 19.5 11.1299"
          stroke="#1A47B8"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import SearchQueryTotals from "@/components/SearchQueryTotals";

export default {
  name: "GlobalSearchResultsTotals",
  data() {
    return {
      search: "global"
    };
  },
  props: {
    featureImages: Boolean,
    featureImagesToggle: Boolean,
    results: Object,
    toggledImage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    toggleText() {
      if (this.toggledImage) {
        return `Hide Images`;
      } else {
        return `Show Images`;
      }
    }
  },
  components: {
    SearchQueryTotals
  },
  methods: {
    toggleEmit() {
      this.$emit("update:image");
    }
  }
};
</script>

<style lang="scss">
.search-results-totals {
  border-top: 1px solid $color__grey--20;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: $spacing-07 0;
  &.suggested {
    padding-bottom: 2.5em;
  }
  &:not(.suggested) {
    margin-top: $spacing-05;
  }
  &__results {
    color: $color__grey--90;
  }
  &__toggle {
    align-items: center;
    display: inline-flex;
    padding: $spacing-02 $spacing-03;
    margin-left: auto;
    span {
      color: $color__blue--60;
      padding: 0 $spacing-02;
    }
  }
}
</style>
